import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { neighbours } from '../data/artifactRealms';

const EDITABLE = /^(INPUT|TEXTAREA|SELECT)$/;

export const useArtifactSlider = (realm, slug, sceneRef) => {
  const navigate = useNavigate();
  const touch = useRef(null);

  useEffect(() => {
    const go = (dir) => {
      const { prev, next } = neighbours(realm, slug);
      navigate(`/product/${dir < 0 ? prev.slug : next.slug}`, { state: { dir } });
    };

    const onKey = (e) => {
      if (EDITABLE.test(e.target.tagName) || e.metaKey || e.ctrlKey || e.altKey) return;
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    };

    const scene = sceneRef.current;
    const onStart = (e) => { touch.current = { x: e.touches[0].clientX, y: e.touches[0].clientY }; };
    const onEnd = (e) => {
      if (!touch.current) return;
      const dx = e.changedTouches[0].clientX - touch.current.x;
      const dy = e.changedTouches[0].clientY - touch.current.y;
      touch.current = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1);
    };

    window.addEventListener('keydown', onKey);
    scene?.addEventListener('touchstart', onStart, { passive: true });
    scene?.addEventListener('touchend', onEnd, { passive: true });
    return () => {
      window.removeEventListener('keydown', onKey);
      scene?.removeEventListener('touchstart', onStart);
      scene?.removeEventListener('touchend', onEnd);
    };
  }, [realm, slug, sceneRef, navigate]);
};
